import { BaseUploadedFiles } from "common/components/BaseUploadedFiles";
import { DocumentRequestFormValue } from "features/documents/pages/documentRequest/types";
import { useFormikContext } from "formik";

export const DocumentRequestUploadedFiles = () => {
  const { values } = useFormikContext<DocumentRequestFormValue>();
  return <BaseUploadedFiles values={values.filesUpload} size="lg" />;
};
